module.exports = __webpack_public_path__ + "static/half-orc-1-3905c6797a1131334adb3812739fa8ee.png";